// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth, hasRol } from "context/AuthContext";

export default function ProtectedRoute({ roles }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: 20 }}>Cargando sesión…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Multi-rol: el usuario pasa si tiene ALGUNO de los roles requeridos
  // (soporta profile.roles array — ej. Marcela: obras + administracion).
  if (roles && roles.length > 0 && !hasRol(profile, ...roles)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
